import { useRef } from "react";
import { SOIL_SAMPLE_BTN } from "../soil-sample-actions/SoilSampleActions";

// After a zone file is uploaded, the lab results are a second file. They attach to
// the zone set that is still being parsed, so this row only appears once that upload landed.
export function SoilSampleZoneResults(props: {
  busy: boolean;
  onUpload: (file: File) => void;
}) {
  const { busy, onUpload } = props;
  const resultsFileRef = useRef<HTMLInputElement>(null);
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-[11px] text-muted">
        Now the results for those zones:
      </span>
      <button
        disabled={busy}
        className={SOIL_SAMPLE_BTN}
        onClick={() => resultsFileRef.current?.click()}
      >
        Upload results…
      </button>
      <span className="text-[10px] text-faint">.csv / .xlsx</span>
      <input
        ref={resultsFileRef}
        type="file"
        accept=".csv,.xlsx,.xls"
        className="hidden"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) onUpload(file);
          if (resultsFileRef.current) resultsFileRef.current.value = "";
        }}
      />
    </div>
  );
}
